module.exports = __webpack_public_path__ + "static/media/research-interactive-feedback.09588d3f.png";